import React from 'react';
import '../styles/theme.css';
import '../styles/TransferHistory.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import TransferHistoryContinueBand from '../components/TransferHistoryContinueBand';
import TransferHistoryLedger from '../components/TransferHistoryLedger';
/* IMPORTS */

function TransferHistoryPage() {
  return (
    <div className="tr-root">
      <div id="transferhistoryheader" className="tr-slot-transferhistoryheader">
        <Navbar activePage={"Transfer History"} />
      </div>
      <div id="transferhistoryledger" className="tr-slot-transferhistoryledger">
        <TransferHistoryLedger />
      </div>
      <div id="transferhistorycontinueband" className="tr-slot-transferhistorycontinueband">
        <TransferHistoryContinueBand />
      </div>
      <div id="transferhistoryfooter" className="tr-slot-transferhistoryfooter">
        <Footer />
      </div>
    </div>
  );
}

export default TransferHistoryPage;